module.exports = __webpack_public_path__ + "assets/img/list-top-logo.6afc7790.png";